import React, { Component, Fragment } from 'react';
import ReactTable from 'Common/ReactTableWrapper';
import { Field } from 'redux-form';
import { get } from 'lodash';

import { formatToCashAllowNegative } from 'Common/FormHelper';
import { TitledCard } from 'Components/';
import {
  EditDailyDepositAccrualsFieldEnum as Fields,
  EditDailyDepositFieldEnum,
} from 'Common/FieldEnum';
import {
  StatusNames,
  MealTypeNamesEnum,
  InputTypes,
} from '../helpers/EditDailyDepositHelpers';
import { MealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';
import { InputField } from 'Common/SemanticWrapper';

export class DailyDepositAccrualsTable extends Component {
  columns = (meal, isTotal = false) => [
    {
      Header: `${meal} Accruals`,
      id: Fields.Status,
      accessor: row => StatusNames[row[Fields.Status]],
      Footer: isTotal ? `Total ${meal} Accruals:` : 'Total:',
    },
    {
      Header: (
        <span>
          Pre-Payments
          <br />
          Made (+)
        </span>
      ),
      id: Fields.PrepayAmount,
      accessor: row => this.renderGridField(row.Index, Fields.PrepayAmount),
      width: 95,
      Footer: this.totalReducer(InputTypes.Sales),
    },
    {
      Header: (
        <span>
          Pre-Payments
          <br />
          Used (-)
        </span>
      ),
      id: Fields.PrepayUsed,
      accessor: row => this.renderGridField(row.Index, Fields.PrepayUsed),
      width: 95,
      Footer: this.totalReducer(InputTypes.Sales),
    },
    {
      Header: (
        <span>
          Charges
          <br />
          Made (-)
        </span>
      ),
      id: Fields.ChargesMade,
      accessor: row => this.renderGridField(row.Index, Fields.ChargesMade),
      width: 95,
      Footer: this.totalReducer(InputTypes.Sales),
    },
    {
      Header: (
        <span>
          Charges
          <br />
          Paid (+)
        </span>
      ),
      id: Fields.ChargesPaid,
      accessor: row => this.renderGridField(row.Index, Fields.ChargesPaid),
      width: 95,
      Footer: this.totalReducer(InputTypes.Sales),
    },
    {
      Header: (
        <span>
          Extra
          <br />
          Credit (-)
        </span>
      ),
      id: Fields.ExtraCredit,
      accessor: row => this.renderGridField(row.Index, Fields.ExtraCredit),
      width: 95,
      Footer: this.totalReducer(InputTypes.Sales),
    },
    {
      Header: 'Accruals',
      id: Fields.Accruals,
      accessor: row => this.renderGridField(row.Index, Fields.Accruals, true),
      width: 95,
      Footer: this.totalReducer(InputTypes.Sales),
    },
  ];

  renderGridField = (index, field, disabled = false) => {
    const { formValues } = this.props;
    const name = `${EditDailyDepositFieldEnum.Accruals}[${index}].${field}`;

    return (
      <Field
        label={false}
        compact
        component={InputField}
        name={name}
        maxLength={8}
        formatOnBlur={formatToCashAllowNegative}
        value={get(formValues, name, 0)}
        disabled={disabled || this.props.disabled}
        handleBlur={this.calculateAccrual(index)}
      />
    );
  };

  calculateAccrual = index => () => {
    const { change, formValues } = this.props;
    const prefix = `${EditDailyDepositFieldEnum.Accruals}[${index}]`;

    const row = get(formValues, prefix, null);

    if (row !== null) {
      change(
        `${prefix}.${Fields.Accruals}`,
        formatToCashAllowNegative(
          parseFloat(row[Fields.PrepayAmount]) -
            parseFloat(row[Fields.PrepayUsed]) -
            parseFloat(row[Fields.ChargesMade]) +
            parseFloat(row[Fields.ChargesPaid]) -
            parseFloat(row[Fields.ExtraCredit])
        )
      );
    }
  };

  totalReducer = inputType => ({ column, data }) =>
    inputType.formatter(
      data.reduce((sum, val) => {
        return sum + Number(val[column.id]['props']['value']);
      }, 0)
    );

  render() {
    const { isSupper, formValues } = this.props;
    const data = formValues[EditDailyDepositFieldEnum.Accruals] || [];

    const indexedData = { studentData: {}, staffData: {}, allData: {} };
    data.forEach((row, index) => {
      row.Index = index;
      if (row[Fields.StatusMerger] === 1) {
        !indexedData.studentData[row[Fields.TypeOfMeal]]
          ? (indexedData.studentData[row[Fields.TypeOfMeal]] = [row])
          : indexedData.studentData[row[Fields.TypeOfMeal]].push(row);
      } else {
        !indexedData.staffData[row[Fields.TypeOfMeal]]
          ? (indexedData.staffData[row[Fields.TypeOfMeal]] = [row])
          : indexedData.staffData[row[Fields.TypeOfMeal]].push(row);
      }
      !indexedData.allData[row[Fields.TypeOfMeal]]
        ? (indexedData.allData[row[Fields.TypeOfMeal]] = [row])
        : indexedData.allData[row[Fields.TypeOfMeal]].push(row);
    });

    const commonProps = {
      loading: this.props.loading,
      className: 'm-t-0 m-b-0',
      getNoDataProps: () => ({ style: { display: 'none' } }),
      getTrProps: () => ({ className: 'no-hover' }),
      getTdProps: (state, rowInfo, column) => {
        const tdProps = {};

        if (column.id !== Fields.Status) {
          tdProps['style'] = { padding: '0px' };
        }

        return tdProps;
      },
      getTheadGroupProps: () => ({ style: { display: 'none' } }),
      getTheadProps: () => ({ style: { display: 'none' } }),
      getTfootProps: () => ({ style: { fontWeight: 'bold' } }),
      showPagination: false,
      menu: false,
      filterable: false,
      sortable: false,
      minRows: 0,
    };

    return isSupper ? (
      <TitledCard title={'Accruals'}>
        <ReactTable
          data={indexedData.studentData[MealTypesEnum.Supper]}
          columns={this.columns(MealTypeNamesEnum.Supper)}
          {...commonProps}
          getTheadProps={() => ({})}
          getTheadGroupProps={() => ({})}
        />
        <ReactTable
          data={indexedData.staffData[MealTypesEnum.Supper]}
          columns={this.columns(MealTypeNamesEnum.Supper)}
          {...commonProps}
        />
        <ReactTable
          data={indexedData.allData[MealTypesEnum.Supper]}
          columns={this.columns(MealTypeNamesEnum.Supper, true)}
          {...commonProps}
          getTrProps={() => ({ style: { display: 'none' } })}
        />
      </TitledCard>
    ) : (
      <Fragment>
        <TitledCard title={'Breakfast Accruals'}>
          <ReactTable
            data={indexedData.studentData[MealTypesEnum.Breakfast]}
            columns={this.columns(MealTypeNamesEnum.Breakfast)}
            {...commonProps}
            getTheadProps={() => ({})}
            getTheadGroupProps={() => ({})}
          />
          <ReactTable
            data={indexedData.staffData[MealTypesEnum.Breakfast]}
            columns={this.columns(MealTypeNamesEnum.Breakfast)}
            {...commonProps}
          />
          <ReactTable
            data={indexedData.allData[MealTypesEnum.Breakfast]}
            columns={this.columns(MealTypeNamesEnum.Breakfast, true)}
            {...commonProps}
            getTrProps={() => ({ style: { display: 'none' } })}
          />
        </TitledCard>
        <TitledCard title={'Lunch Accruals'}>
          <ReactTable
            data={indexedData.studentData[MealTypesEnum.Lunch]}
            columns={this.columns(MealTypeNamesEnum.Lunch)}
            {...commonProps}
            getTheadProps={() => ({})}
            getTheadGroupProps={() => ({})}
          />
          <ReactTable
            data={indexedData.staffData[MealTypesEnum.Lunch]}
            columns={this.columns(MealTypeNamesEnum.Lunch)}
            {...commonProps}
          />
          <ReactTable
            data={indexedData.allData[MealTypesEnum.Lunch]}
            columns={this.columns(MealTypeNamesEnum.Lunch, true)}
            {...commonProps}
            getTrProps={() => ({ style: { display: 'none' } })}
          />
        </TitledCard>
        <TitledCard title={'Other Accruals'}>
          <ReactTable
            data={indexedData.studentData[MealTypesEnum.Other]}
            columns={this.columns(MealTypeNamesEnum.Other)}
            {...commonProps}
            getTheadProps={() => ({})}
            getTheadGroupProps={() => ({})}
          />
          <ReactTable
            data={indexedData.staffData[MealTypesEnum.Other]}
            columns={this.columns(MealTypeNamesEnum.Other)}
            {...commonProps}
          />
          <ReactTable
            data={indexedData.allData[MealTypesEnum.Other]}
            columns={this.columns(MealTypeNamesEnum.Other, true)}
            {...commonProps}
            getTrProps={() => ({ style: { display: 'none' } })}
          />
        </TitledCard>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/modifydailydeposits/components/AccrualsTable.js